interface Tier {
  letter: string;
  label: string;
  status: string;
  featured?: boolean;
}

const tiers: Tier[] = [
  { letter: 'P', label: 'PAN verified', status: '✓' },
  { letter: 'G', label: 'GST verified', status: '✓' },
  { letter: '★', label: 'Mela Verified', status: 'Gold', featured: true },
];

export function BadgeStack() {
  return (
    <div className="flex flex-col gap-2 w-full max-w-[240px]">
      {tiers.map((t, i) => (
        <div
          key={i}
          className={`flex items-center gap-3 px-3.5 py-2.5 rounded-md shadow-card border ${
            t.featured ? 'bg-gold-50 border-gold-500' : 'bg-white border-ink-200'
          }`}
        >
          <div
            className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold flex-shrink-0 ${
              t.featured ? 'bg-gold-500 text-white' : 'bg-ink-100 text-ink-700'
            }`}
          >
            {t.letter}
          </div>
          <div className={`flex-1 text-[12px] font-medium ${t.featured ? 'text-gold-700 font-semibold' : 'text-ink-800'}`}>
            {t.label}
          </div>
          <span className={`text-[10px] font-mono font-medium ${t.featured ? 'text-gold-700' : 'text-green-700'}`}>
            {t.status}
          </span>
        </div>
      ))}
    </div>
  );
}
